export { IrManagePage as default } from '@/components/pages/Ir/Manage'
